import { CardFooterLinks } from '../../../components/molecules/Card/CardFooter';
import { mediaDir } from '../../../appolloConfig';
import { RessourceContent } from '../../../types/ressource/ressource.def';
import { getRessourceTypeInfo } from '../../../theme/ressourceTypeInfo';

export const getRessourceCardLinks = (
  entry: Omit<RessourceContent, 'challengeRessourceType' | ''>
): CardFooterLinks[] => {
  const links: CardFooterLinks[] =
    (entry?.ressources &&
      entry?.ressources?.map(m => ({
        href: m.lien ?? (m.media && mediaDir + m.media[0]?.url),
        icon: getRessourceTypeInfo(m.type.nom).icon,
        text: m.titre,
        color: getRessourceTypeInfo(m.type.nom).color,
        variant: 'ressource'
      }))) ||
    [];
  return [...links];
};
